import { ConnectorService } from "@gtmhub/connectors/connectorService";
import { IPatchConnectorParams, SyncSchedule } from "@gtmhub/connectors/models";
import { UIErrorHandlingService } from "@gtmhub/error-handling";
import { IComponentOptions, IOnChangesObjectOf, IPromise } from "angular";

export interface IProvisioningCadenceBindings {
  connectorId: string;
  disabled: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ProvisioningCadenceCtrl extends IProvisioningCadenceBindings {}

export class ProvisioningCadenceCtrl {
  currentSyncScheduleType: string;
  isOpen: false; // whether the drop down is open

  static $inject = ["ConnectorService", "UIErrorHandlingService"];

  constructor(private connectorService: ConnectorService, private uiErrorHandlingService: UIErrorHandlingService) {}

  $onChanges(onChangesObj: IOnChangesObjectOf<IProvisioningCadenceBindings>): void {
    if (onChangesObj.connectorId != null && onChangesObj.connectorId.currentValue) {
      this.loadSyncSchedule();
    }
  }

  syncScheduleChanged(syncScheduleType: SyncSchedule): IPromise<unknown> {
    this.currentSyncScheduleType = syncScheduleType;
    const params: IPatchConnectorParams = {
      syncSchedule: syncScheduleType,
    };
    return this.connectorService.patchConnection(this.connectorId, params).catch((error) => {
      this.uiErrorHandlingService.handleModal(error);
      return this.loadSyncSchedule();
    });
  }

  isSelected(syncScheduleType: SyncSchedule) {
    return this.currentSyncScheduleType === syncScheduleType;
  }

  private loadSyncSchedule(): IPromise<void> {
    return this.connectorService.getConnection(this.connectorId).then((connector) => {
      this.currentSyncScheduleType = connector.syncSchedule;
    });
  }
}

export const ProvisioningCadenceComponent: IComponentOptions = {
  bindings: {
    connectorId: "<",
    disabled: "<",
  },
  controller: ProvisioningCadenceCtrl,
  templateUrl: require("./provisioning-cadence.component.jade"),
};
